import {
  PROFILE_KEY,
  updateProfileAction
} from '@gymaholic/packages'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'

const ACTION_TYPE = {
  UPDATE_INTEREST_FOCUS: 'UPDATE_INTEREST_FOCUS'
}

export function updateInterestFocusProfileAction (value) {
  return updateProfileAction({
    type: getActionStrReduxUtil(ACTION_TYPE.UPDATE_INTEREST_FOCUS, value),
    payload: {
      key: PROFILE_KEY.INTEREST_FOCUS,
      value
    }
  })
}
